<template>
  <!-- Misma estructura que Conciliacion.vue mientras carga: cabecera, KPIs, solapas y las dos tablas -->
  <v-card>
    <div class="d-flex align-center px-7 pt-6 pb-4">
      <v-skeleton-loader type="avatar" class="sk-icon mr-3"></v-skeleton-loader>
      <div class="flex-grow-1">
        <v-skeleton-loader type="heading" max-width="460"></v-skeleton-loader>
        <v-skeleton-loader type="text" max-width="300" class="mt-2"></v-skeleton-loader>
      </div>
    </div>

    <v-row no-gutters class="px-4">
      <v-col v-for="n in 4" :key="n" cols="12" sm="6" md="3" class="px-3 py-3">
        <v-skeleton-loader type="text" max-width="140"></v-skeleton-loader>
        <v-skeleton-loader type="heading" max-width="200" class="mt-2"></v-skeleton-loader>
        <v-skeleton-loader type="text" max-width="160" class="mt-2"></v-skeleton-loader>
      </v-col>
    </v-row>

    <div class="d-flex px-7 pt-6 pb-4">
      <v-skeleton-loader v-for="n in 3" :key="n" type="text" width="140" class="mr-8"></v-skeleton-loader>
    </div>
    <v-divider></v-divider>

    <v-row class="px-4 py-4">
      <v-col v-for="n in 2" :key="n" cols="12" lg="6">
        <v-card outlined>
          <v-skeleton-loader type="list-item-avatar-two-line"></v-skeleton-loader>
          <v-skeleton-loader type="table-thead, table-row-divider@6" class="px-4 pb-4"></v-skeleton-loader>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  name: "ConciliacionSkeleton",
};
</script>

<style scoped>
.sk-icon >>> .v-skeleton-loader__avatar {
  width: 28px;
  height: 28px;
}
</style>
